import { ReactElement } from 'react'
import { useTranslation } from 'next-i18next'
import { Warning } from '@components/icons'
import cn from 'classnames'
import s from '@pagestyles/Wishlist.module.scss'

export const NoWishlistFound = (): ReactElement => {
    const { t } = useTranslation(['wishlist'])

    return (
        <div className={cn(s['no-wishlist-items'], 'toast-container')}>
            <div className={cn('flex justify-between toast-content')}>
                <div className={cn('flex space-x-3 toast-content-inner')}>
                    <Warning />
                    <div
                        className={cn(
                            'flex-1 text-xl leading-snug text-t-1 font-medium toast-text'
                        )}
                    >
                        {t(
                            'wishlist|You have no wish list found. Please create new one.'
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
